import { render, staticRenderFns } from "./FoodCard.vue?vue&type=template&id=755c1407&scoped=true"
import script from "./FoodCard.vue?vue&type=script&lang=ts"
export * from "./FoodCard.vue?vue&type=script&lang=ts"
import style0 from "./FoodCard.vue?vue&type=style&index=0&id=755c1407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755c1407",
  null
  
)

export default component.exports
import {QCard,QItem,QItemSection,QItemLabel,QBtn,QImg,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QItem,QItemSection,QItemLabel,QBtn,QImg,QCardSection})
